import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import humanFormat from 'human-format';

const Span = styled.span`
  font-weight: ${props => props.theme.fontWeightBold};
  font-family: ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.bodyColor};
  line-height: 120%;
  text-transform: uppercase;
`;

export default function MetricNumber({ n }) {
  const v = Number.isNaN(n) ? '-' : humanFormat(n, { decimals: 1, separator: '' });
  return <Span>{v}</Span>;
}

MetricNumber.propTypes = { n: PropTypes.number.isRequired };
